<script setup lang="ts">
import type { AttachmentTapeBadgeUi } from '@/common/utils/attachmentTapeRowStatus'

defineProps<{
  ui: AttachmentTapeBadgeUi
}>()
</script>

<template>
  <div
    v-if="ui.visible"
    class="attachment-tape-badge"
    :class="ui.cssClass"
    :title="ui.title"
  >
    <i :class="ui.iconClass" />
  </div>
</template>

<style scoped lang="scss">
.attachment-tape-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);

  i {
    font-size: 0.75rem;
  }

  &--idle {
    background: #16a34a;
  }

  &--staged {
    background: #f59e0b;
  }

  &--platform-pending {
    background: transparent;
    color: var(--primary-color, #1e3a6e);
    border: 2px solid var(--primary-color, #1e3a6e);
    box-shadow: none;
  }

  &--editing {
    background: var(--primary-color, #1e3a6e);
  }

  &--awaiting_ws,
  &--downloading {
    background: var(--primary-color, #1e3a6e);

    i {
      animation: attachment-tape-badge-spin 1s linear infinite;
    }
  }

  &--error,
  &--discarded {
    background: #ef4444;
  }
}

@keyframes attachment-tape-badge-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
